module.exports = __webpack_public_path__ + "img/image_card_one.d26937ee.png";